const Opinie = () => {
    return (
        <section className="flex flex-row items-center w-full justify-center mq450:h-auto bg-[#939ACB]">
        <div id="opinie" className="flex flex-col max-w-[1280px] w-full justify-between px-[24px] gap-[64px] mq450:px-4  mq450:gap-[32px] h-full py-[80px] mq450:py-[32px]">
        <div id="top" className="flex flex-row mq450:flex-col gap-[64px] mq450:gap-[24px] justify-center items-end">
            <div id="left" className="flex flex-col w-full gap-[12px]">
                <div id="title" className='font-silka-semibold font-[600] text-[16px] leading-[130%] text-white mq450:text-[14px] uppercase'>OPINIE</div>
                <div id="subtitle" className='font-silka-semibold font-[600] text-[40px] leading-[130%] text-white mq450:text-[24px]'>Co mówią nasi klienci?</div>
            </div>
        </div>
        
        <div id="content" className="flex flex-row w-full gap-[24px] mq450:flex-col">
        <div id="card" className="flex flex-col w-full mq450:w-auto rounded-[16px] p-[32px] mq450:p-[24px] bg-white h-[196px] justify-between mq450:h-auto mq450:gap-[24px] ">
            <div id="top" className="text-[16px] font-silka-semibold font-[400] text-[#362F5B] leading-[150%]">
            Uwielbiam <b>NightBloom!</b> Sen stał się głębszy i budzę się wypoczęta jak nigdy wcześniej.
            </div>
            <div className="flex flex-col gap-[24px] w-full">
            <div id="line" className="flex w-full h-[1px] bg-[#362F5B]"></div>
            <div id="bottom" className="flex flex-row gap-[16px] items-center w-full">
                <img src="/opinie-1.svg" className="w-[56px]" />
                <div id="text" className="flex flex-col gap-[8px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Katarzyna Zielińska</div>
                    <div id="subtitle" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B]">Mama dwójki dzieci, 32 lata</div>
                </div>
            </div>
            </div>
        </div>
        <div id="card" className="flex flex-col w-full mq450:w-auto  rounded-[16px] p-[32px] bg-white h-[196px] justify-between mq450:h-auto mq450:gap-[24px]">
            <div id="top" className="text-[16px] font-silka-semibold font-[400] text-[#362F5B] leading-[150%]">
            <b>BrightMind</b> pomógł mi skupić się podczas pracy zdalnej. Zauważyłem różnicę już po tygodniu stosowania.
            </div>
            <div className="flex flex-col gap-[24px]">
            <div id="line" className="flex w-full h-[1px] bg-[#362F5B]"></div>
            <div id="bottom" className="flex flex-row gap-[16px] items-center">
                <img src="/opinie-2.svg" className="w-[56px]" />
                <div id="text" className="flex flex-col gap-[8px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Tomasz Wiśniewski</div>
                    <div id="subtitle" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B]">Programista, 29 lat</div>
                </div>
            </div>
            </div>
        </div>
        <div id="card" className="flex flex-col w-full mq450:w-auto  rounded-[16px] p-[32px] bg-white h-[196px] justify-between mq450:h-auto mq450:gap-[24px]">
            <div id="top" className="text-[16px] font-silka-semibold font-[400] text-[#362F5B] leading-[150%]">
            <b>GlowLeaf</b> to mój ulubiony suplement! Moje paznokcie i włosy nigdy nie wyglądały lepiej.
            </div>
            <div className="flex flex-col gap-[24px]">
            <div id="line" className="flex w-full h-[1px] bg-[#362F5B]"></div>
            <div id="bottom" className="flex flex-row gap-[16px] items-center">
                <img src="/opinie-3.svg" className="w-[56px]" />
                <div id="text" className="flex flex-col gap-[8px]">
                    <div id="title" className="text-[18px] font-silka-semibold font-[500] text-[#362F5B]">Sylwia Nowak</div>
                    <div id="subtitle" className="text-[16px] font-silka-semibold font-[300] text-[#362F5B]">Kosmetolog, 35 lat</div>
                </div>
            </div>
            </div>
        </div>
        </div>

        </div>
      </section>
    );
  };
  
  export default Opinie;
  